import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://xntuwuexxqaorxwdmtlr.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhudHV3dWV4eHFhb3J4d2RtdGxyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3OTI2OTcyNzAsImV4cCI6MjEwODI3MzI3MH0.LK4b8OMWSKnr1_WzNQLmem34ZQsNtf5tPaY78aUsGHs';

const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false
  }
});

export default supabase;